import React, { useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify';
import "common/css/master.css";
import { saveSubWeeklyPeriodsSvc, saveBlockSizeSvc } from './subjectAllocationSvc'

const SubjectAllocationTable = (props) => {
    const { filters, setFilters, syllabusId, lstSubjectAllocation, setLstSubjectAllocation, subjectAllocationId, setSubjectAllocationId, editSubjectAllocation, deleteSubjectAllocation, lstSubId, handleSelectChange } = props;

    const [lstSubjectAllocationFiltered, setLstSubjectAllocationFiltered] = useState([]);
    const [selSubjectAllocationId, setSelSubjectAllocationId] = useState(0);
    const [weeklyPeriods, setTotalPeriods] = useState(0);
    const [lstSubjectId, setLstSubjectId] = useState([]);
    const [lstSvcSubjectPeriods, setLstSvcSubjectPeriods] = useState([]);
    // const [filters, setFilters] = useState({ sharedSlotNo: null, sub: null })
    // const [showOnlyBlockPeriods, setShowOnlyBlockPeriods] = useState(false)
    const col1Refs = useRef(Array.from({ length: lstSubjectAllocation.length }, () => React.createRef()));
    const col2Refs = useRef(Array.from({ length: lstSubjectAllocation.length }, () => React.createRef()));
    var lstTmpSyllabus = [], lstTmpSubject = []
    useEffect(() => {
        // console.log("useEffect in SubjectAllocationTable component called, lstSubjectAllocation", lstSubjectAllocation);
        setLstSubjectAllocationFiltered(lstSubjectAllocation);
        setLstSubjectId([]);
        for (var j = 0; j < lstSubjectAllocation.length; j++) {
            var obj = { subId: lstSubjectAllocation[j].subId, periods: lstSubjectAllocation[j].weeklyPeriod, blockSz: lstSubjectAllocation[j].blockSz, sharedSlot: lstSubjectAllocation[j].sharedSlotNo };
            lstTmpSubject.push(obj);
        }
        // console.log(lstTmpSubject)
        calculateTotalPeriods(lstTmpSubject);
        setLstSvcSubjectPeriods(lstTmpSubject)
    }, [lstSubjectAllocation]);


    useEffect(() => {
        console.log('filtering called...')
        const filtered = (lstSubjectAllocation || []).filter((obj) => {
            console.log('obj:', obj)
            const sharedSlotNo = obj.sharedSlotNo || "";
            const sub = (obj.sub || "").toLowerCase();

            const filterSub = (filters.sub || "").toLowerCase();
            const filterSlot = filters.sharedSlotNo || "";

            if (filters.showOnlyBlockPeriods && parseInt(obj.blockSz) < 2) {
                return false;
            }

            if (filterSub && !sub.includes(filterSub)) {
                return false;
            }

            if (filterSlot && sharedSlotNo.toString() !== filterSlot) {
                return false;
            }

            return true;
        });
        console.log('filtered: ', filtered)
        setLstSubjectAllocationFiltered(filtered);

    }, [filters, lstSubjectAllocation])


    useEffect(() => {
        // console.log("useEffect in SubjectAllocationTable component called subjectAllocationId", subjectAllocationId);
        setSelSubjectAllocationId(subjectAllocationId);
    }, [subjectAllocationId]);

    useEffect(() => {
        setLstSubjectId(lstSubId);
    }, [lstSubId]);

    const colgrp = <colgroup>
        <col width="80"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="20"></col>
        <col width="60"></col>
        <col width="40"></col>
    </colgroup>

    const calculateTotalPeriods = (pLstSubjectAllocation) => {
        // console.log("Method called: calculateTotalPeriods");
        // console.log("Parameters passed:", { pLstSubjectAllocation });
        let sum = 0;
        const arrSharedSlot = [];
        pLstSubjectAllocation.forEach((item) => {
            if (item.sharedSlot == 0) {
                console.log('item.periods:', item.periods)
                // console.log(sum + (item.periods * Math.max(...[item.blockSz, 1]) || 0))
                sum += (item.periods || 0);
            } else {
                if (!arrSharedSlot.includes(item.sharedSlot)) {
                    // console.log(item)
                    // console.log('sum= ', total, 'item.periods = ', item.periods, 'item.blockSz = ', Math.max(...[item.blockSz, 1]), 'prod = ', item.periods * Math.max(item.blockSz, 1))
                    sum += (item.periods) || 0
                    arrSharedSlot.push(item.sharedSlot);
                }
            }
        });
        console.log("Total periods calculated:", sum);
        /*         let total=0;
                pLstSubjectAllocation.forEach((item) => {
                    if (item.sharedSlot !== 0 && !arrSharedSlot.includes(item.sharedSlot)) {
                        total += (item.periods * Math.max(...[item.blockSz, 1])) || 0
                        arrSharedSlot.push(item.sharedSlot);
                    }
                })
                console.log('total = ', total); */
        setTotalPeriods(sum);
    };

    function handleKeyDown(e, rowIdx, colIdx) {
        if (e.keyCode === 13) { // Enter key
            e.preventDefault();
            const nextRowIdx = rowIdx + 1;
            if (colIdx === 0 && col1Refs.current[nextRowIdx]) {
                col1Refs.current[nextRowIdx].current.focus();
            }
            if (colIdx === 1 && col2Refs.current[nextRowIdx]) {
                col2Refs.current[nextRowIdx].current.focus();
            }
        }
    }


    function handleWeeklyPeriodChange(pSubId, pSybId, pVal, pSharedSlot) {
        // console.log(pSubId, pSybId, pVal)
        pVal = parseInt(pVal)
        const updatedAllocationList = lstSubjectAllocation.map((item) => {
            // Find the matching row by subId
            if (item.subId === pSubId) {
                return {
                    ...item,
                    weeklyPeriod: pVal // Updates the text value on screen immediately
                };
            }
            return item;
        });

        // 3. Update your master allocation state to unlock the input field
        setLstSubjectAllocation(updatedAllocationList);
        lstTmpSubject = [...lstSvcSubjectPeriods];
        // console.log("lstTmpSubject", lstSvcSubjectPeriods);

        // var subIdx = existsAt("subId", pSubId, lstSvcSubjectPeriods);
        var subIdx = lstTmpSubject.findIndex(item => item.subId === pSubId);
        if (subIdx > -1) {
            // console.log("found")
            lstTmpSubject[subIdx].sharedSlot = pSharedSlot;
            lstTmpSubject[subIdx].periods = pVal;
        }
        else {
            // console.log("not found")
            lstTmpSubject.push({ subId: pSubId, periods: pVal, sharedSlot: pSharedSlot })
        }

        // console.log("lstTmpSubject", lstTmpSubject);
        setLstSvcSubjectPeriods(lstTmpSubject);
        calculateTotalPeriods(lstTmpSubject);
        // lstTmpStudent[studentIdx].lstScore[idx] = pVal;
        // console.log("lstTmpStudent", lstTmpStudent);
        // console.log("calcSummary calling from handleStudentScoreChange");

    }

    const handleBlockSizeChange = (pSubId, pSybId, pVal, pSharedSlot) => {
        // console.log(pSubId, pSybId, pVal)
        pVal = parseInt(pVal)
        lstTmpSubject = [...lstSvcSubjectPeriods];
        // console.log("lstTmpSubject", lstSvcSubjectPeriods);
        // var subIdx = existsAt("subId", pSubId, lstSvcSubjectPeriods);
        var subIdx = lstTmpSubject.findIndex(item => item.subId === pSubId);
        if (subIdx > -1) {
            // console.log("found")
            lstTmpSubject[subIdx].blockSz = pVal;
            lstTmpSubject[subIdx].sharedSlot = pSharedSlot;
        }
        else {
            // console.log("not found")
            lstTmpSubject.push({ subId: pSubId, blockSz: pVal, sharedSlot: pSharedSlot })
        }
        // console.log("lstTmpSubject", lstTmpSubject);
        setLstSvcSubjectPeriods(lstTmpSubject);
        // lstTmpStudent[studentIdx].lstScore[idx] = pVal;
        // console.log("lstTmpStudent", lstTmpStudent);
        // console.log("calcSummary calling from handleStudentScoreChange");
    }


    function existsAt(pKey, id, arr) {
        // console.log(pKey, id, arr)
        var idx = -1;

        for (var i = 0; i < arr.length; i++) {
            // console.log(arr[i][pKey])
            // console.log(id)
            if (arr[i][pKey] === id) {
                idx = i;
                break;
            }
        }

        return idx;
    }


    function saveWeeklyPeriod() {
        // console.log(lstSvcSubjectPeriods)
        var data = {
            syllabusId: syllabusId
            , lstPeriod: lstSvcSubjectPeriods.map((obj) => ({ subId: obj.subId, periods: obj.periods, blockSz: obj.blockSz }))
        }

        saveSubWeeklyPeriodsSvc(data, cbSaveWeeklyPeriod);
    }

    const saveBlockSize = () => {
        // console.log(lstSvcSubjectPeriods)
        var data = { syllabusId: syllabusId, lstPeriod: lstSvcSubjectPeriods }
        saveBlockSizeSvc(data, cbSaveWeeklyPeriod);
    }

    function cbSaveWeeklyPeriod(data) {
        // console.log("cbMarkStudentScore called, data", data);
        if (data.status === "Success") {
            toast.success(data.message)
            calculateTotalPeriods(lstSvcSubjectPeriods);
            // calcSummary();
        } else {
            toast.error(data.message)
        }
    }

    const handleFilterChange = (field, value) => {
        console.log('field:', field, 'value:', value)
        setFilters(prevFilters => {
            const newFilters = { ...prevFilters, [field]: value };
            return newFilters;
        });
    };

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                <input
                                    className="form-control inp-search"
                                    id="sub"
                                    placeholder="Subject"
                                    defaultValue={filters.sub || ''}
                                    onChange={(e) => handleFilterChange('sub', e.target.value)}
                                />

                            </th>
                            <th >
                                Weekly Periods
                            </th>
                            <th >
                                <input type='checkbox' style={{marginRight:8}}
                                    onClick={(e) => handleFilterChange('showOnlyBlockPeriods', e.target.checked)}
                                    defaultChecked={filters.showOnlyBlockPeriods} />Block
                            </th>
                            <th>
                                <input
                                    className="form-control inp-search"
                                    id="sharedSlotNo"
                                    placeholder="Shared Slot"
                                    defaultValue={filters.sharedSlotNo || ''}
                                    onChange={(e) => handleFilterChange('sharedSlotNo', e.target.value)}
                                />
                            </th>
                            <th >
                                Select
                            </th>
                            <th >
                                Facility
                            </th>
                            <th >
                                Action
                            </th>
                        </tr>
                    </thead>
                </table>
                <div
                    className="tableDiv"
                    style={{ height: "60vh", pointerEvents: "auto", zIndex: 1, position: "relative" }}
                >
                    <table className="tableLayout" style={{ position: "relative" }}>
                        {colgrp}
                        <tbody id="diaryMonthlySubjectAllocationTable">
                            {lstSubjectAllocationFiltered &&
                                lstSubjectAllocationFiltered.map((subjectAllocation, i) => (
                                    <tr
                                        key={subjectAllocation.subjectAllocationId + "_" + subjectAllocation.subId}
                                        onClick={() => setSubjectAllocationId(subjectAllocation.subjectAllocationId)}
                                        className={subjectAllocation.subId === selSubjectAllocationId ? "selected" : ''}
                                    >
                                        <td className="text-left">{subjectAllocation.sub}</td>
                                        <td>
                                            <input maxLength="5"
                                                style={{
                                                    margin: '0 auto',
                                                    width: '98%',
                                                    textAlign: 'right'
                                                }}
                                                type="text"
                                                className="form-control"
                                                onClick={(e) => e.target.select()}
                                                defaultValue={subjectAllocation.weeklyPeriod}
                                                onKeyDown={(e) => handleKeyDown(e, i, 0)}
                                                tabIndex={i + 1}
                                                onChange={(e) => handleWeeklyPeriodChange(subjectAllocation.subId, syllabusId, e.target.value, subjectAllocation.sharedSlotNo)}
                                            />
                                        </td>
                                        <td>
                                            <input maxLength="5"
                                                style={{
                                                    margin: '0 auto',
                                                    width: '98%',
                                                    textAlign: 'right'
                                                }}
                                                type="text"
                                                className="form-control"
                                                onClick={(e) => e.target.select()}
                                                defaultValue={subjectAllocation.blockSz}
                                                onKeyDown={(e) => handleKeyDown(e, i, 1)}
                                                onChange={(e) => handleBlockSizeChange(subjectAllocation.subId, syllabusId, e.target.value, subjectAllocation.sharedSlotNo)}
                                            />
                                        </td>
                                        {/* <td className="text-center">{subjectAllocation.weeklyPeriod}</td> */}
                                        <td className="text-center">{subjectAllocation.sharedSlotNo ? subjectAllocation.sharedSlotNo : "-"}</td>
                                        <td className="text-center">
                                            <input type="checkbox"
                                                className="form-check-input"
                                                checked={!!lstSubjectId && lstSubjectId.includes(subjectAllocation.subId)}
                                                onChange={() => handleSelectChange(subjectAllocation.subId)}
                                                onClick={(e) => { e.stopPropagation(); }}
                                            />
                                        </td>
                                        <td className="text-center">{subjectAllocation.facility ? subjectAllocation.facility : "-"}</td>
                                        <td className="text-center">
                                            <span
                                                onClick={() => editSubjectAllocation(subjectAllocation)}
                                                title="Edit Subject Allocation Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Edit
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div style={{ paddingRight: "17px" }}>
                    <table className="tableLayout" style={{ width: "calc(100% + 18px)" }}>
                        <tfoot>
                            <tr>
                                <td width="80"><b>Total Periods Allocated</b></td>
                                <td width="35" style={{ textAlign: 'right' }}>{weeklyPeriods}</td>
                                <td width="35" style={{ textAlign: 'right' }}></td>
                                <td width="155"></td>
                            </tr>
                            <tr>
                                <td width="80"></td>
                                <td className='text-right' width="35">
                                    <button type="button" className='btn btn-info ' onClick={(e) => saveWeeklyPeriod()} >Save</button>
                                </td>
                                <td className='text-right' width="35">
                                    <button type="button" className='btn btn-info ' onClick={(e) => saveBlockSize()} >Save</button>
                                </td>
                                <td width="155"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

            </div>
        </div>
    );
}

export default SubjectAllocationTable;